import { NgClass } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';
import { PartnerService } from '@services/feature-service/partner.service';

@Component({
  imports: [NgClass, TranslateModule],
  selector: 'app-calio-footer',
  templateUrl: './calio-footer.component.html'
})
export class CalioFooterComponent implements OnInit {

  private partnerService = inject(PartnerService);

  protected showFooter = signal(false);
  private partnerLoadEvent$: any;
  protected readonly currYear = new Date().getFullYear();

  protected readonly companyName = environment.companyName;
  protected readonly foundingYear = environment.foundingYear;

  ngOnInit() {
    this.partnerLoadEvent$ = this.partnerService.partnerLoadEvent.subscribe(partner => {
      if (partner?.uuid && partner?.has_active_subscription) {
        this.showFooter.set(!this.partnerService.isWhitelabeledPartner);
      }
      this.partnerLoadEvent$.unsubscribe();
    });
  }
}
